
import { loadScript } from './helpers';

declare global {
    interface Window {
        grecaptcha: any;
    }
}

// Get the key from the config object or fallback to the provided default
const getSiteKey = () => {
    return window.APP_CONFIG?.RECAPTCHA_SITE_KEY || '6LcZbiosAAAAALXSVlmgPw8qhfLn5cYUQtP_EhBm';
};

export const RECAPTCHA_SITE_KEY = getSiteKey();

// Function to dynamically load the reCAPTCHA script using the configured key
export const loadRecaptcha = async () => {
    const key = getSiteKey();
    if (!key) {
        console.warn('No reCAPTCHA site key configured.');
        return;
    }
    
    // Check if already loaded to avoid duplicates
    if (document.getElementById('recaptcha-script')) return;

    try {
        await loadScript(`https://www.google.com/recaptcha/enterprise.js?render=${key}`, 'recaptcha-script');
        // Execute a 'page_view' action immediately to register traffic and complete setup
        // This clears the "Incomplete setup" warning in GCP
        getRecaptchaToken('page_view').catch(e => console.log('Initial captcha ping failed (expected if bot)', e));
    } catch (e) {
        console.error("Failed to load reCAPTCHA script", e);
    }
};

export const getRecaptchaToken = async (action: string): Promise<string> => {
    return new Promise((resolve, reject) => {
        if (!window.grecaptcha || !window.grecaptcha.enterprise) {
            console.warn('reCAPTCHA not loaded, skipping (development mode or blocked).');
            // For dev robustness we resolve a mock token
            resolve('mock-token-dev'); 
            return;
        }

        const siteKey = getSiteKey();

        window.grecaptcha.enterprise.ready(async () => {
            try {
                const token = await window.grecaptcha.enterprise.execute(siteKey, { action });
                if (!token) {
                    throw new Error("Failed to generate reCAPTCHA token (empty response).");
                }
                resolve(token);
            } catch (error) {
                console.error('reCAPTCHA execution failed:', error);
                reject(error);
            }
        });
    });
};
